import angular from 'angular';
import delegationCardComponent from './delegationCard.component';

let delegationCardModule = angular.module('delegationCard', [])

.component('delegationCard', delegationCardComponent)

.name;

export default delegationCardModule;



// WEBPACK FOOTER //
// ./client/app/components/delegationsList/delegationCard/delegationCard.js